import { NotAuthorizedComponent, NotFoundComponent } from '@microsec/components';
import { NOT_AUTHORIZED_URL, NOT_FOUND_URL } from '@microsec/constants';
import { MODULES } from './products/modules';
import { RedirectionComponent } from '@ids-components';
import { Routes } from '@angular/router';
import { canActivateAuthRole } from '@microsec/guards';

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: MODULES.REDIRECTION.ROUTE, pathMatch: 'full' },
      {
        path: MODULES.REDIRECTION.ROUTE,
        component: RedirectionComponent,
        canActivate: [canActivateAuthRole],
        data: { Animation: 'rootRouteChangeAnimation' },
      },
      {
        path: MODULES.SYSTEM_SETTINGS.ROUTE,
        canActivate: [canActivateAuthRole],
        loadChildren: () => import('./products/system-settings/system-settings.module').then((m) => m.SystemSettingsModule),
        data: {
          Animation: 'rootRouteChangeAnimation',
          role: 'superuser',
        },
      },
      {
        path: MODULES.ORGANIZATION_MANAGEMENT.ROUTE,
        canActivate: [canActivateAuthRole],
        loadChildren: () => import('./products/organization-management/organization-management.module').then((m) => m.OrganizationManagementModule),
        data: { Animation: 'rootRouteChangeAnimation' },
      },
      {
        path: MODULES.PROJECT_MANAGEMENT.ROUTE,
        canActivate: [canActivateAuthRole],
        loadChildren: () => import('./products/project-management/project-management.module').then((m) => m.ProjectManagementModule),
        data: { Animation: 'rootRouteChangeAnimation' },
      },
      {
        path: MODULES.USER_SETTINGS.ROUTE,
        canLoad: [canActivateAuthRole],
        loadChildren: () => import('./products/user-settings/user-settings.module').then((m) => m.UserSettingsModule),
        data: { Animation: 'rootRouteChangeAnimation' },
      },
      {
        path: MODULES.SYSTEM_GETTING_STARTED.ROUTE,
        loadComponent: () =>
          import('./products/system-getting-started/system-getting-started.component').then((m) => m.SystemGettingStartedComponent),
        data: { Animation: 'rootRouteChangeAnimation' },
      },
      {
        path: MODULES.PROJECT_GETTING_STARTED.ROUTE,
        canActivate: [canActivateAuthRole],
        loadComponent: () =>
          import('./products/project-getting-started/project-getting-started.component').then((m) => m.ProjectGettingStartedComponent),
        data: { Animation: 'rootRouteChangeAnimation' },
      },
    ],
  },
  {
    path: NOT_AUTHORIZED_URL.replace('/', ''),
    component: NotAuthorizedComponent,
    data: { Animation: 'rootRouteChangeAnimation' },
  },
  {
    path: '**',
    redirectTo: NOT_FOUND_URL.replace('/', ''),
    pathMatch: 'full',
  },
  {
    path: NOT_FOUND_URL.replace('/', ''),
    component: NotFoundComponent,
    data: { Animation: 'rootRouteChangeAnimation' },
  },
];
